import { Model } from './model';
import { Gruppo } from './gruppo';
import { DisposizioneCompagniaAllegato } from './disposizione-compagnia-allegato';

export class DisposizioneCompagnia extends Model {
  static apiUrl = 'disposizioni-compagnie';

  gruppo_id: number;
  titolo: string;
  contenuto: string;
  gruppo?: Gruppo;
  allegati: DisposizioneCompagniaAllegato[] = [];

  deserialize(input: any): DisposizioneCompagnia {
    let retV: DisposizioneCompagnia = new DisposizioneCompagnia();
    retV = super.deserialize(input) as DisposizioneCompagnia;
    if (input?.gruppo) {
      retV.gruppo = new Gruppo().deserialize(input.gruppo);
    }
    if (input?.allegati) {
      retV.allegati = input.allegati.map((a: any) => new DisposizioneCompagniaAllegato().deserialize(a));
    }
    return retV;
  }

  public getHumanIdentifier() {
    return this.titolo;
  }

  static getDefaultSortKey() {
    return 'created_at';
  }
}
